import { Action } from './actions';

export const defaultState = {
  isUpdating: false,
  isValidating: false,
  result: undefined,
  error: undefined,
  requiresConfirmation: false,
};

export default function shippingAddressReducer(state = defaultState, action = {}) {
  const body = action.payload || {};

  switch (action.type) {
    case Action.ShippingAddress.UpdatePending:
    case Action.ShippingAddress.UpdateCustomerInfoPending:
    case Action.Reship.ReshipCardPending:
      return {
        ...state,
        isUpdating: true,
        result: undefined,
        error: undefined,
      };

    case Action.ShippingAddress.UpdateCompleted:
    case Action.ShippingAddress.UpdateCustomerInfoCompleted:
      return {
        ...state,
        isUpdating: false,
        result: body?.shippingAddress || {},
      };

    case Action.ShippingAddress.UpdateFailed:
    case Action.ShippingAddress.UpdateCustomerInfoFailed:
      return {
        ...state,
        isUpdating: false,
        result: body?.status !== 400 ? body?.response?.shippingAddress || {} : {},
        error: {
          ...body?.response,
          status: body.status,
        },
      };

    case Action.Reship.ReshipCardCompleted:
      return {
        ...state,
        isUpdating: false,
        requiresConfirmation: body?.requiresConfirmation,
      };

    case Action.Reship.ReshipCardFailed:
      // eslint-disable-next-line no-case-declarations
      const requiresConfirmation = body?.status === 400
        && body?.response?.message === 'Please check your email to confirm the request to ship your card to a new address.';
      return {
        ...state,
        isUpdating: false,
        requiresConfirmation,
        error: requiresConfirmation ? undefined : action.payload,
      };

    case Action.ShippingAddress.ValidationPending:
      return {
        ...state,
        isValidating: true,
        result: undefined,
        error: undefined,
      };

    case Action.ShippingAddress.ValidationCompleted:
      return {
        ...state,
        isValidating: false,
        result: body?.shippingAddress || {},
      };

    case Action.ShippingAddress.ValidationFailed:
      return {
        ...state,
        isValidating: false,
        result: body?.response?.shippingAddress || {},
        error: {
          ...body?.response,
          status: action.payload.status,
        },
      };

    case Action.ShippingAddress.Reset:
      return {
        ...state,
        isUpdating: false,
        result: undefined,
        error: undefined,
      };

    default:
      return state;
  }
}
